import { render, staticRenderFns } from "./companyrules.vue?vue&type=template&id=726bd2a4&scoped=true&"
import script from "./companyrules.vue?vue&type=script&lang=js&"
export * from "./companyrules.vue?vue&type=script&lang=js&"
import style0 from "./companyrules.vue?vue&type=style&index=0&id=726bd2a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726bd2a4",
  null
  
)

export default component.exports